import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import inputFormReducer from '../store/modules/inputFormSlice';


export const store = configureStore({
  reducer: {
    inputform: inputFormReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
